export default "__VITE_ASSET__BasFajRb__"